<template>
    <v-card>
        <v-card-title>hi</v-card-title>
    </v-card>
</template>
<script>
export default {
    layout: 'app',
    mounted() {
        console.log('Component mounted.')
    },
    created: function () {
        Echo.channel('queue-monitor')
            .listen('.QueueMonitor', (e) => {
                console.log(e);
            })
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ExampleComponent.vue